import { dispatchScheduleEvent } from "../schedule-history/dispatch";
import { parseScheduleDocument } from "./schedule-json";

export function loadScheduleText(text: string) {
  const document = parseScheduleDocument(text);
  dispatchScheduleEvent({ type: "document/load", document });
}
